module.exports = __webpack_public_path__ + "img/la-caja.7de1e6f9.png";